export class RoleModel {
  RoleListAPI: string = "";
  UpdateAPI: string = "";
  GetRoleByIdAPI: string = "";
  GetGridTransList: string = "";
}
